import type React from 'react';
import Button from 'app/shared/core/Button';
import IconCall from 'images/icons/call-teal.svg';
import type { ListingDetails } from 'app/types/listingDetails.type';
import { emitTrackPhoneLeadForPaidPropertyEvent } from 'app/shared/models/Clickstream/ContactClickstreamEvents';
import { getListingCardCallButtonStyles, callButtonAnchorStyles } from './ListingCardCallButton.styles';

interface ListingCardCallButtonProps {
  listing: ListingDetails;
  onClick?: () => void;
}

const ListingCardCallButton: React.FC<ListingCardCallButtonProps> = ({ listing, onClick }) => {
  const phoneNumber = listing.listedBy?.contactPhone;
  const isMultifamily = listing.isPaidMultifamily || listing.trusted;

  const handleCallClick = (e: React.MouseEvent) => {
    e.stopPropagation();

    emitTrackPhoneLeadForPaidPropertyEvent({
      listing,
      triggerLocation: 'search_results',
      triggerObject: 'property_card',
    });

    onClick?.();
  };

  const shouldShowButton = !!(listing && listing.active !== false && phoneNumber && isMultifamily);

  const listingCardCallButtonStyles = getListingCardCallButtonStyles();

  if (!shouldShowButton) {
    return null;
  }

  type AnchorProps = React.AnchorHTMLAttributes<HTMLAnchorElement>;

  const anchorProps: Pick<AnchorProps, 'href'> = {
    href: `tel:${phoneNumber}`,
  };

  return (
    <div className={listingCardCallButtonStyles} data-testid="listing-card-call-button">
      <Button
        htmlTag="a"
        aria-label="Call"
        className={`ListingCardCallButton ${callButtonAnchorStyles}`}
        data-testid="listing-card-call-button-btn"
        btnType="primary-outline"
        full
        bold
        size="md"
        icon={{ src: IconCall, width: '18px', height: '16px', alt: '' }}
        onClick={handleCallClick}
        {...anchorProps}
      >
        Call
      </Button>
    </div>
  );
};

export default ListingCardCallButton;
